type GeolocationOptions = {
  enableHighAccuracy?: boolean
  timeout?: number
  maximumAge?: number
}

const DEFAULT_OPTIONS: GeolocationOptions = {
  enableHighAccuracy: false,
  timeout: 15000,
  maximumAge: 300000,
}

const getCurrentPosition = (
  options: GeolocationOptions
): Promise<GeolocationPosition> =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, options)
  })

export const getUserPosition = async (): Promise<GeolocationPosition> => {
  if (!navigator.geolocation) {
    throw new Error('Geolocation not supported')
  }

  try {
    return await getCurrentPosition({
      ...DEFAULT_OPTIONS,
      enableHighAccuracy: true,
      timeout: 10000,
    })
  } catch {
    return getCurrentPosition(DEFAULT_OPTIONS)
  }
}
